<template>
  <v-container fluid fill-height class="hero">
    <v-layout justify-center align-center column pa-5>
      <div class="display-3 font-weight-bold text-xs-center white--text">
        Leaderboard
      </div>
      <v-btn icon large class="white--text display-2" @click="scrollToDetails">
        <v-icon id="scroll">arrow_downward</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "LandingHero",
  methods: {
    scrollToDetails() {
      document.querySelector("#detailsContainer").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
  }
};
</script>

<style scoped>
.hero {
  background: url("https://source.unsplash.com/kOfVxiO1LOk") center;
  background-size: cover;
  width: 100%;
  height: 100%;
  max-height: 100vh;
}
#scroll {
  font-size: 1em;
}
</style>
